import React from "react";
import NFTCards from "../../components/nftCards/NFTCards";
import { nftFeatureKey } from "../../store/featureKeys";
import { useSelector, useDispatch } from "react-redux";
import * as nftActions from "../../store/actions/nftActions";
import { useState, useEffect } from "react";
import { authFeatureKey } from "../../store/featureKeys";

import "./Fav.css";

function Fav() {
  let dispatch = useDispatch();
  const [nfts, setNFts] = useState();
  const nftData = useSelector((state) => state[nftFeatureKey]);
  const { currentUser } = useSelector((state) => {
    return state[authFeatureKey];
  });
  useEffect(() => {
    if (!nfts) {
      dispatch(nftActions.fetchLikedNFTs(currentUser));
    }
  }, []);
  return (
    <div className="favorites">
      <h1 className="space-heading margin-heading">FAVOURITES</h1>

      <NFTCards nfts={nftData.nfts} length={nftData.nfts.length}/>
    </div>
  );
}

export default Fav;
